module.exports = __webpack_public_path__ + "static/media/aceptado-marker.41b65fc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/img/aceptado-marker.svg
// module id = 871
// module chunks = 0